import config from '@/config'
import * as ics from 'ics'
import moment from 'moment'

export const createICS = (dueDate, offerName, offerId, quotationNumber, isApproval = true) => {
  const dueDateMoment = moment(dueDate)

  if (!dueDateMoment.isValid()) {
    throw new Error("Missing Due Date, can't add to outlook")
  }

  const approvalLink = isApproval ? `${config.domain}/offers/approvals` : `${config.domain}/offers/sourcingDecisions`
  const event = {
    start: [
      parseInt(dueDateMoment.format('YYYY')),
      parseInt(dueDateMoment.format('M')),
      parseInt(dueDateMoment.format('D')),
      0,
      0,
    ],
    duration: { hours: 24 },
    title: `[E Approval][${quotationNumber}]${offerName}`,
    categories: ['E Approval'],
    status: 'CONFIRMED',
    busyStatus: 'BUSY',
    htmlContent: `
    <!DOCTYPE html>
    <html>
      <body>
        <p>${isApproval ? 'Offer Number:' : 'RFQ Number:'} <b>${quotationNumber}</b></p>
        <p>Offer Name: <b>${offerName}</b></p>
        <p>Approval Due Date: <b>${dueDateMoment.format('DD-MMM-YYYY')}</b></p>
       
        Please approve via the E-approval system by <b>${dueDateMoment.format('DD-MMM-YYYY')}</b>.

        <br/>

        <div>
          You can view the offer in
          <a href="${config.domain}/offers/${offerId}">${config.domain}/offers/${offerId}</a>
        </div>
        <div>
          You can view all your approvals in
          <a href="${approvalLink}">${approvalLink}</a>
        </div>


      </body>
    </html>`,
  }

  ics.createEvent(event, (error, value) => {
    if (error) {
      console.error(error)
      return
    }
    const blob = new Blob([value])
    const fileDownloadUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = fileDownloadUrl
    link.setAttribute('download', 'download.ics')

    // Append to html link element page
    document.body.appendChild(link)

    // Start download
    link.click()

    // Clean up and remove the link
    link.parentNode.removeChild(link)
  })
}

export const createEMLFile = (htmlContent) => {
  const blob = new Blob([htmlContent])
  const fileDownloadUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = fileDownloadUrl
  link.setAttribute('download', 'email.eml')

  // Append to html link element page
  document.body.appendChild(link)

  // Start download
  link.click()

  // Clean up and remove the link
  link.parentNode.removeChild(link)
}
